import { Component } from 'react';
import { connect } from 'react-redux';
import { isFetching } from '../selectors';
import { analyze, close } from '../actions';
import { CameraImageInput } from './CameraImageInput';
import { CanvasWrapper, ScannerWrapper, ButtonHolder, CancelButton, ScanButton, RightActionsWrapper } from './style';

type State = $TSFixMe;

class CameraScanner extends Component<{}, State> {
    cameraImageInput: $TSFixMe;
    state = {
        isReady: false,
    };
    cameraImageInputRef = (c: $TSFixMe) => (this.cameraImageInput = c);
    handleIsReadyChanged = (isReady: $TSFixMe) => {
        this.setState({
            isReady,
        });
        if ((this.props as $TSFixMe).onIsReadyChanged) {
            (this.props as $TSFixMe).onIsReadyChanged(isReady);
        }
    };
    handleFrameCapture = () => {
        if (this.cameraImageInput) {
            const frame = this.cameraImageInput.capture();
            (this.props as $TSFixMe).handleAnalyze(frame);
        }
    };
    handleClose = () => (this.props as $TSFixMe).handleClose();
    render() {
        const { isReady } = this.state;
        return (
            <ScannerWrapper>
                {/* @ts-expect-error $TSFixMeError: No overload matches this call. */}
                <CanvasWrapper isOpened={(this.props as $TSFixMe).isOpened}>
                    <CameraImageInput
                        // @ts-expect-error $TSFixMeError: No overload matches this call.
                        onIsReadyChanged={this.handleIsReadyChanged}
                        isOpened={(this.props as $TSFixMe).isOpened}
                        isFetching={(this.props as $TSFixMe).isFetching}
                        ref={this.cameraImageInputRef}
                    />
                </CanvasWrapper>
                <ButtonHolder>
                    <RightActionsWrapper>
                        <CancelButton onClick={this.handleClose} />
                        {isReady && (
                            <ScanButton
                                onClick={this.handleFrameCapture}
                                disabled={(this.props as $TSFixMe).isFetching}
                            />
                        )}
                    </RightActionsWrapper>
                </ButtonHolder>
            </ScannerWrapper>
        );
    }
}

export default connect(
    // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
    (state, { scope }) => ({
        isFetching: isFetching(state, { scope }),
    }),
    // @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
    (dispatch, { scope }) => ({
        // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe, { container }: $TSFixMe) => any' is not assignable to paramet...
        handleAnalyze: (imageData: $TSFixMe) => dispatch(analyze(scope, imageData)),
        // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe) => void' is not assignable to parameter of type 'Action<any>'.
        handleClose: () => dispatch(close(scope)),
    })
)(CameraScanner);
